export const getBookingFeeText = (currency) => {
  if (currency === "USD") {
    return "";
  } else {
    return "inc. VAT";
  }
};
